import React from "react";
import { Navigate } from "react-router-dom";

//AuthenticationInner pages
// import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
// import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
// import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
// import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
// import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
// import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
// import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
// import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
// import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
// import Error500 from "../pages/AuthenticationInner/Errors/Error500";
// import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
// import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";
// import Register from "../pages/Authentication/Register";
//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import ResetPassword from "../pages/Authentication/ResetPassword";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import { StaffsPage } from "../pages/Staffs/Staffs";
import {
  Spaces,
  Menus,
  MenuItems,
  Sites,
  Kitchens,
  Settings,
  Dashboard,
  SubSpaces,
  Clickers,
  DeliveryTimeReport,
  ManageTeam,
  Splash,
  AppVersion
} from "../pages";
import Links from "../pages/Locations/Links";
import KitchenTablets from "../pages/Locations/KitchenTablets";
import KitchenAppSettings from "../pages/Locations/Kitchens/AppSettings";
import Register from "../pages/Authentication/Register";
import ValidateEmail from "../pages/Authentication/ValidateEmail";
import ValidationEmailSent from "../pages/Authentication/ValidationEmailSent";
import AcceptInvitation from "../pages/Authentication/AcceptInvitation";
import RegisterFromInvitation from "../pages/Authentication/RegisterFromInvitation";
import DeclineInvitation from "../pages/Authentication/DeclineInvitation";
import ServiceStation from "../pages/Reports/Service Station";
import Orders from "../pages/Reports/Daily Orders";
import MenuItemReport from "../pages/Reports/Menu Item";
import PeriodicReportPage from "../pages/Reports/Periodic Report";
import FeedbackDashboard from "../pages/Feedback";
import RegistrationSuccessful from "../pages/Authentication/RegistrationSuccessful";
import Announcements from "../pages/Locations/Announcements/page";
import Experience from "../pages/Experience";
import SpaceManagementExperience from "../pages/SpaceManagementExperience";
import StationExperience from "../pages/StationExperience";
import ValidateEmailMobile from "../pages/Authentication/ValidateEmailMobile";
import MySpaces from "../pages/MySpaces";
import MyMenus from "../pages/MyMenus"
const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard />, name: "dashboard" },

  { path: "/report/delivery-time", component: <DeliveryTimeReport />, name: "delivery_time_report" },
  {
    path: "/report/service-station",
    component: <ServiceStation />,
    name: "service_station_report",
  },
  {
    path: "/report/orders",
    component: <Orders />,
    name: "order",
  },
  {
    path: "/report/menu-item",
    component: <MenuItemReport />,
    name: "order",
  },
  {
    path: "/feedback",
    component: <FeedbackDashboard />,
    name: "feedback",
  },
  { path: "/mymenus", component: <MyMenus />, name: "mymenus" },
  { path: "/myspaces", component: <MySpaces />, name: "myspaces" },
  {
    path: "/menus", component: <Menus />, name: "menu"
  },
  { path: "/links", component: <Links />, name: "link" },
  { path: "/menu-items/:menuid", component: <MenuItems />, name: "menu_item" },
  { path: "/subspaces/:spaceid", component: <SubSpaces />, name: "space" },
  { path: "/sites", component: <Sites />, name: "site" },
  { path: "/spaces", component: <Spaces />, name: "space" },
  { path: "/kitchens", component: <Kitchens />, name: "kitchen" },
  { path: "/kitchens/:kitchenId/tablets", component: <KitchenTablets />, name: "kitchen_tablets" },
  { path: "/kitchens/:kitchenId/app-settings", component: <KitchenAppSettings />, name: "kitchen" },
  { path: "/clickers", component: <Clickers />, name: "clickers" },
  { path: "/manage-team", component: <ManageTeam />, name: "manage_team" },
  { path: "/announcements", component: <Announcements />, name: "Announcements" },
  // { path: "/station-experience", component: <StationExperience />, name: "station_experience", useNonAuthLayout: true },
  //User Profile
  { path: "/profile", component: <UserProfile />, name: "profile" },

  // this route should be at the end of all other routes

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
];

const rootRoutes = [
  { path: "/staffs", component: <StaffsPage />, name: "staff" },
  { path: "/kitchen-tablets", component: <KitchenTablets />, name: "kitchen_tablets" },
  { path: "/kitchens/:kitchenId/tablets", component: <KitchenTablets />, name: "kitchen_tablets" },
  { path: "/settings", component: <Settings />, name: "setting" },
  { path: "/settings/splash", component: <Splash />, name: "splash" },
  { path: "/settings/app-version", component: <AppVersion />, name: "app_version" },
  { path: "/report/periodic-email", component: <PeriodicReportPage />, name: "periodic_report" },
  // { path: "/settings/vouchers", component: <Vouchers />, name: "vouchers" },
];
const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/onboarding", component: <Experience /> },
  { path: "/space-management-onboarding", component: <SpaceManagementExperience /> },
  { path: "/auth/validate-email/:token", component: <ValidateEmail /> },
  { path: "/auth/validate-email-mobile/:token", component: <ValidateEmailMobile /> },
  { path: "/auth/validate-email-sent", component: <ValidationEmailSent /> },
  { path: "/auth/accept-invitation/:token", component: <AcceptInvitation /> },
  { path: "/auth/register-from-invitation/:token", component: <RegisterFromInvitation /> },
  { path: "/auth/decline-invitation/:token", component: <DeclineInvitation /> },
  { path: "/auth/registration-success", component: <RegistrationSuccessful /> },
  //AuthenticationInner pages
  // { path: "/auth-signin-basic", component: <BasicSignIn /> },
  // { path: "/auth-signin-cover", component: <CoverSignIn /> },
  // { path: "/auth-signup-basic", component: <BasicSignUp /> },
  // { path: "/auth-signup-cover", component: <CoverSignUp /> },
  // { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  // { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  // { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  // { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  // { path: "/auth-logout-basic", component: <BasicLogout /> },
  // // { path: "/auth-logout-cover", component: <CoverLogout /> },
  // { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  // { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  // { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  // { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  // { path: "/auth-404-basic", component: <Basic404 /> },
  // { path: "/auth-404-cover", component: <Cover404 /> },
  // { path: "/auth-404-alt", component: <Alt404 /> },
  // { path: "/auth-500", component: <Error500 /> },
  // { path: "/auth-pass-create-basic", component: <BasicPasswCreate /> },
  // { path: "/auth-pass-create-cover", component: <CoverPasswCreate /> },
  // { path: "/auth-offline", component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes, rootRoutes };
